import { render, staticRenderFns } from "./NextPage.vue?vue&type=template&id=08042415"
import script from "./NextPage.vue?vue&type=script&lang=js"
export * from "./NextPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports